"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMappedSignalValue = isMappedSignalValue;
exports.autoMapSignals = autoMapSignals;
const fast_fuzzy_1 = require("fast-fuzzy");
function isMappedSignalValue(mappedSignalId) {
    if (typeof mappedSignalId === 'number') {
        return true;
    }
    return typeof mappedSignalId === 'string' && mappedSignalId.length > 0;
}
function findMatchForDesignSignal(designSignal, packageSignals, sigmaModelSignals, sigmaModelToPackageSignalMap) {
    for (const packageSignal of packageSignals) {
        if (designSignal.name.toLowerCase() === packageSignal.name.toLowerCase()) {
            return packageSignal.id;
        }
    }
    for (const sigmaModelSignal of sigmaModelSignals) {
        const sigmaSignalName = sigmaModelSignal.name || String(sigmaModelSignal.id);
        if (designSignal.name.toLowerCase() === sigmaSignalName.toLowerCase()) {
            const mappedPackageSignal = sigmaModelToPackageSignalMap.get(sigmaModelSignal.id);
            if (mappedPackageSignal) {
                return mappedPackageSignal.id;
            }
        }
    }
    for (const sigmaModelSignal of sigmaModelSignals) {
        if (sigmaModelSignal.aliases) {
            const aliasMatch = sigmaModelSignal.aliases.some((alias) => alias.toLowerCase() === designSignal.name.toLowerCase());
            if (aliasMatch) {
                const mappedPackageSignal = sigmaModelToPackageSignalMap.get(sigmaModelSignal.id);
                if (mappedPackageSignal) {
                    return mappedPackageSignal.id;
                }
            }
        }
    }
    const packageSignalNames = packageSignals.map((signal) => signal.name);
    const matches = (0, fast_fuzzy_1.search)(designSignal.name, packageSignalNames, {
        returnMatchData: true,
        threshold: 0.6,
        ignoreCase: true,
        ignoreSymbols: true,
        normalizeWhitespace: true,
    });
    if (matches.length > 0) {
        const bestMatch = matches[0];
        if (bestMatch) {
            const bestMatchName = bestMatch.item;
            const bestMatchSignal = packageSignals.find((signal) => signal.name === bestMatchName);
            if (bestMatchSignal) {
                return bestMatchSignal.id;
            }
        }
    }
    return null;
}
function autoMapSignals(designSignals, packageSignals, sigmaModelType, baseComponentModelResolver) {
    const signalMap = {};
    let sigmaModelSignals = [];
    if (sigmaModelType && baseComponentModelResolver) {
        try {
            const modelClass = baseComponentModelResolver.Models.find((m) => m.Model.type === sigmaModelType);
            if (modelClass) {
                sigmaModelSignals = modelClass.Model.signals || [];
            }
        }
        catch {
        }
    }
    const sigmaModelToPackageSignalMap = new Map();
    for (const packageSignal of packageSignals) {
        if (packageSignal.sigmaModelSignal) {
            sigmaModelToPackageSignalMap.set(packageSignal.sigmaModelSignal, packageSignal);
        }
    }
    const mappedSigmaModelSignals = sigmaModelSignals.filter((sigmaSignal) => {
        return sigmaModelToPackageSignalMap.has(sigmaSignal.id) || sigmaModelToPackageSignalMap.has(sigmaSignal.name);
    });
    for (const designSignal of designSignals) {
        const matchedPackageSignalId = findMatchForDesignSignal(designSignal, packageSignals, mappedSigmaModelSignals, sigmaModelToPackageSignalMap);
        if (matchedPackageSignalId !== null) {
            signalMap[designSignal.id] = matchedPackageSignalId;
        }
    }
    return signalMap;
}
//# sourceMappingURL=automap-signals.js.map